import React from 'react'
import { cx } from '@/lib/utils'
import styles from './Inline.module.scss'

type Gap = '0' | '1' | '2' | '3' | '4' | '6' | '8'
type Align = 'start' | 'center' | 'end' | 'stretch' | 'baseline'
type Justify = 'start' | 'center' | 'end' | 'between' | 'around'

interface InlineProps {
  children: React.ReactNode
  gap?: Gap
  align?: Align
  justify?: Justify
  wrap?: boolean
}

const gapMap: Record<Gap, string> = {
  '0': styles.gap0, '1': styles.gap1, '2': styles.gap2, '3': styles.gap3,
  '4': styles.gap4, '6': styles.gap6, '8': styles.gap8,
}

const alignMap: Record<Align, string> = {
  start: styles.alignStart, center: styles.alignCenter, end: styles.alignEnd,
  stretch: styles.alignStretch, baseline: styles.alignBaseline,
}

const justifyMap: Record<Justify, string> = {
  start: styles.justifyStart, center: styles.justifyCenter, end: styles.justifyEnd,
  between: styles.justifyBetween, around: styles.justifyAround,
}

export const Inline: React.FC<InlineProps> = ({
  children, gap = '2', align = 'center', justify = 'start', wrap = false,
}) => (
  <div className={cx(styles.inline, gapMap[gap], alignMap[align], justifyMap[justify], wrap && styles.wrap)}>
    {children}
  </div>
)
